import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";

export interface Category {
  id: string;
  name: string;
  description?: string | null;
  icon?: string | null;
  color?: string | null;
  imageUrl?: string | null;
  parentId?: string | null;
  sortOrder?: number | null;
  productCount?: number | null;
  isActive?: boolean | null;
}

export interface CategoryPayload {
  name: string;
  description?: string | null;
  icon?: string | null;
  color?: string | null;
  imageUrl?: string | null;
  parentId?: string | number | null;
  sortOrder?: number | null;
  isActive?: boolean;
}

export async function getCategories(): Promise<ApiResponse<Category[]>> {
  return apiClient.get<Category[], object>("/categories");
}

export async function getPosCategories(): Promise<ApiResponse<Category[]>> {
  return apiClient.get<Category[], object>("/pos/products/categories");
}

export async function createCategory(
  payload: CategoryPayload
): Promise<ApiResponse<Category>> {
  return apiClient.post<Category, CategoryPayload>("/categories", payload);
}

export async function updateCategory(
  id: string,
  payload: CategoryPayload
): Promise<ApiResponse<Category>> {
  return apiClient.put<Category, CategoryPayload>(`/categories/${id}`, payload);
}

export async function deleteCategory(id: string): Promise<ApiResponse<void>> {
  return apiClient.delete<void>(`/categories/${id}`);
}
